import { useEffect, useRef } from 'react';
/**
 * Prevents body scroll while active. Restores the previous overflow
 * style and scroll position when deactivated or unmounted.
 *
 * Uses a ref-count approach so nested overlays share one lock cleanly.
 */
let lockCount = 0;
let savedScrollY = 0;
let savedBodyStyle = null;
function lockBody() {
    if (lockCount === 0) {
        savedScrollY = window.scrollY;
        const { style } = document.body;
        savedBodyStyle = {
            overflow: style.overflow,
            position: style.position,
            top: style.top,
            width: style.width,
        };
        style.overflow = 'hidden';
        style.position = 'fixed';
        style.top = `-${savedScrollY}px`;
        style.width = '100%';
    }
    lockCount += 1;
}
function unlockBody() {
    lockCount = Math.max(0, lockCount - 1);
    if (lockCount === 0 && savedBodyStyle !== null) {
        const { style } = document.body;
        style.overflow = savedBodyStyle.overflow;
        style.position = savedBodyStyle.position;
        style.top = savedBodyStyle.top;
        style.width = savedBodyStyle.width;
        window.scrollTo(0, savedScrollY);
        savedBodyStyle = null;
    }
}
/**
 * Locks body scroll when `active` is true.
 */
export function useScrollLock(active) {
    const lockedRef = useRef(false);
    useEffect(() => {
        if (typeof window === 'undefined')
            return;
        if (active && !lockedRef.current) {
            lockBody();
            lockedRef.current = true;
        }
        else if (!active && lockedRef.current) {
            unlockBody();
            lockedRef.current = false;
        }
        return () => {
            if (lockedRef.current) {
                unlockBody();
                lockedRef.current = false;
            }
        };
    }, [active]);
}
